import BookOutlined from '@mui/icons-material/BookOutlined';
import { Stack } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import AccessEventsDataGrid, { AccessEventRow } from 'v2/components/AccessEventsDataGrid/AccessEventsDataGrid';
import EmptyStateOverview from 'v2/components/EmptyStateOverview/EmptyStateOverview';
import OverviewContent from 'v2/components/OverviewContent/OverviewContent';
import SectionPaper from 'v2/components/SectionPaper/SectionPaper';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import useDeviceDetailsAccessEvents from 'v2/hooks/useDevices/useDeviceDetailsAccessEvents';

interface Props {
  deviceId: string;
}

const AccessEventsTab: React.FC<Props> = ({ deviceId }) => {
  const { translation } = useTranslation();
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });

  const { deviceDetailsAccessEvents, loadingGetDeviceDetailsAccessEvents } = useDeviceDetailsAccessEvents({
    handleFetchError,
    deviceId
  });

  const rows: AccessEventRow[] = (deviceDetailsAccessEvents ?? []).map((event) => ({
    id: event.id,
    createdAt: event.createdAt,
    visitorName: event.visitor.name,
    visitorEmail: event.visitor.email,
    action: event.action,
    reason: event.reason
  }));

  const hasEvents = rows.length > 0;

  return (
    <SectionPaper>
      <Stack spacing={2}>
        <OverviewContent
          loading={loadingGetDeviceDetailsAccessEvents}
          hasData={hasEvents}
          hasResults={hasEvents}
          table={
            <AccessEventsDataGrid
              className="background-level2 not-clickable"
              rows={rows}
              loading={loadingGetDeviceDetailsAccessEvents}
              hideDeviceColumn
            />
          }
          noResults={null}
          noData={
            <EmptyStateOverview
              icon={BookOutlined}
              title={translation.device_has_no_events}
              content={translation.device_no_access_events}
              sx={{ height: 'auto', pt: 8, pb: 4 }}
            />
          }
        />
      </Stack>
    </SectionPaper>
  );
};

export default AccessEventsTab;
